module.exports = __webpack_public_path__ + "img/interpack-badge.78296aee.svg";